<template>
    <div>
        <div class="header">
            <div class="title">
                您好，
            </div>
            <div class="subtitle">
                需要您的真實姓名以利使用本服務
            </div>
        </div>
        <div class="content">
            <div>
                <input type="text"
                       v-model="name"
                       class="name"
                       placeholder="輸入真實姓名">
            </div>
            <div>
                <input type="email"
                       v-model="email"
                       class="email"
                       placeholder="輸入常用信箱">
            </div>
            <span class="email-info"><img src="@/assets/img/notices.png">訂單通知將寄送至此，請確實填寫。</span>
            <div class="flex">
                <span>
                    如何稱呼您？
                </span>
                <div class="gender">
                    <div class="female"
                         :class="{active: gender === 'female'}"
                         @click="setGender('female')">
                        小姐
                    </div>
                    <div class="separation"></div>
                    <div class="male"
                         :class="{active: gender === 'male'}"
                         @click="setGender('male')">
                        先生
                    </div>
                </div>
            </div>
            <div class="ic">
                <span>
                    是否有邀請碼？
                </span>
                <div>
                    <input type="text" v-model="code" class="code" placeholder="輸入邀請碼">
                </div>
            </div>
            <div class="buttons">
                <div class="button" @click="setMe" :class="btnClass">
                    確定
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Swal from "sweetalert2";

    export default {
        name: 'Register',
        data() {
            return {
                name: '',
                gender: 'female',
                email: '',
                code: '',
            }
        },
        computed: {
            btnClass() {
                return {
                    active: this.checkData(),
                }
            },
            ...mapGetters(['user'])
        },
        methods: {
            setGender(gender) {
                this.gender = gender;
            },
            setMe() {
                if (! this.checkData()) {
                    return;
                }

                let payload = {
                    name: this.name,
                    gender: this.gender,
                    email: this.email,
                };
                if (this.code && this.code.length > 0) {
                    payload.code = this.code;
                }

                this.updateMe(payload).then(() => {
                    this.$router.push({name: 'home'});
                }).catch(err => {
                    let message = err.response.data.message;
                    if (err.response.data.errors) {
                        message = Object.values(err.response.data.errors).reduce((arr, msg) => {
                            return arr.concat(msg);
                        }, []).join("\n");
                    }

                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: message,
                    });
                });
            },
            validateEmail(email) {
                return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
            },
            checkData() {
                return this.name.trim().length > 0 && ['female', 'male'].includes(this.gender) && this.validateEmail(this.email);
            },
            ...mapActions(['getMe', 'updateMe'])
        },
        created() {
          if (this.$route.query.ic) {
              this.code = this.$route.query.ic;
          }
        },
        mounted() {
            this.getMe().then(() => {
                this.name = this.user.name;
                this.gender = this.user.gender;
            });
        }
    };
</script>

<style scoped>
    .title {
        color: #000000;
        font-size: 26px;
        font-weight: 600;
        letter-spacing: 2.01px;
        line-height: 37px;
        text-align: center;
        margin-top: 130px;
    }

    .subtitle {
        height: 21px;
        color: #000000;
        font-size: 15px;
        letter-spacing: 0.67px;
        line-height: 21px;
        text-align: center;
    }

    .name {
        width: 235px;
        border-color: transparent;
        border-bottom-color: #D8D8D8;
        margin-top: 55px;
        padding: 10px;
    }

    .email-info {
        margin-top: 5px;
        font-size: 14px;
        color: #339933;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .email-info > img {
        width: 20px;
        margin-right: 2px;
    }

    .email {
        width: 235px;
        border-color: transparent;
        border-bottom-color: #D8D8D8;
        margin-top: 25px;
        padding: 10px;
    }

    .code {
        width: 235px;
        border-color: transparent;
        border-bottom-color: #D8D8D8;
        padding: 10px;
    }

    .ic {
        display: flex;
        flex-direction: column;
    }

    .ic > span {
        height: 20px;
        margin-top: 42px;
        width: 235px;
        align-self: center;
        text-align: left;
        color: #000000;
        font-size: 14px;
        letter-spacing: 1.2px;
        line-height: 20px;
    }

    .flex {
        display: flex;
        flex-direction: column;
    }

    .flex > span {
        height: 20px;
        margin-top: 42px;
        width: 235px;
        align-self: center;
        text-align: left;
        color: #000000;
        font-size: 14px;
        letter-spacing: 1.2px;
        line-height: 20px;
    }

    .separation {
        height: 34px;
        width: 1px;
        background-color: #D8D8D8;
    }

    .gender {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 235px;
        align-self: center;
        margin-top: 14px;
        font-size: 14px;
        font-weight: 500;
        ine-height: 20px;
    }

    .gender > .female {
        width: 50%;
        height: 34px;
        line-height: 34px;
        cursor: pointer;
    }

    .gender > .male {
        width: 50%;
        height: 34px;
        line-height: 34px;
        cursor: pointer;
    }

    .gender > .active {
        color: #339933;
    }

    .buttons > .button {
        height: 41px;
        width: 235px;
        border-radius: 20.5px;
        background-color: #EEEEEE;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 70px auto 0 auto;
        cursor: pointer;
    }

    .button.active {
        background-color: rgba(51,153,51,0.85);
        color: white;
    }
</style>
